import { createContext, useContext } from 'react'

import { fontSize, size } from '@styles/theme';
import styled from '@emotion/styled/macro';

import { Toast } from '@base-ui/react/toast';

const animationTimeout = 3500

const ToastContainer = styled.div`
  border-radius: 100px;
  background-color: #333333F2;
  padding: ${size(1)} ${size(1.5)};
  font-size: ${fontSize('xs')};
  text-align: center;
  animation: fadeInAndOut ${animationTimeout}ms ease-in-out;
`

function ToastList() {
  const { toasts } = Toast.useToastManager();

  return toasts.map((activeToast) => {
    return (
      <Toast.Root
        key={activeToast.id}
        toast={activeToast}
        style={{ display: activeToast.limited && 'none' }}
        swipeDirection={['down', 'right', 'left', 'up']}>
        <ToastContainer>
          {activeToast.text}
        </ToastContainer>
      </Toast.Root>
    )
  })
}

const ToastViewport = styled(Toast.Viewport)`
  position: fixed;
  display: flex;
  justify-content: center;
  z-index: 10000000;
  width: fit-content;
  margin: 0 auto;
  bottom: ${size(11)};
  right: 0;
  left: 0;
  top: auto;
`

const FeedbackToastContext = createContext();
const FeedbackToastProvider = ({ children }) => {

  return (
    <Toast.Provider limit={1} timeout={animationTimeout}>
      <Toast.Portal>
        <ToastViewport>
          <ToastList />
        </ToastViewport>
      </Toast.Portal>
      {children}
    </Toast.Provider>
  )
}

const useFeedbackToastContext = () => useContext(FeedbackToastContext)

export default useFeedbackToastContext

export { FeedbackToastContext, FeedbackToastProvider, useFeedbackToastContext }
